import { useOrdersStore } from '@pulse/composables/useOrdersStore';

export default function useReturnsRouting() {
  const store = useOrdersStore(useRuntimeConfig())();

  return {
    async next() {
      const email = store.currentOrder.customerEmail;
      const ref = store.currentOrder.orderNumber;

      window.location.replace(`${store.returnsUrl}#?ref=${ref}&email=${email}`);
    },

    start() {
      navigateTo('/process');
    },

    validate() {
      return this.start();
    },
  };
}
